import Reset from '../Components/reset_component/usr_reset'

const Reset_Page = () => {
    return ( 
        <Reset/>
     );
}
 
export default Reset_Page;